import React from "react";
import { LocalAudioTrack } from "twilio-video";
import { Divider, GridItem, SimpleGrid, Text } from "@chakra-ui/react";
import { FiMic } from "react-icons/fi";
import { GiSpeaker } from "react-icons/gi";
import { MdComputer } from "react-icons/md";
import { BiSlider } from "react-icons/bi";

import { SELECTED_AUDIO_INPUT_KEY } from "context/session/VideoProvider/constants";
import { useDevices, useVideoContext } from "hooks/session";
import { AudioButton } from "../SessionCall/Buttons";
import AudioLevelIndicator from "./AudioLevelIndicator";
import DeviceSelector from "./DeviceSelector";

const AudioPreview: React.FC = () => {
  const { localTracks, getLocalAudioTrack } = useVideoContext();
  const { audioInputDevices } = useDevices();
  const track = localTracks.find(
    track => track.kind === "audio"
  ) as LocalAudioTrack;

  const replaceTrack = (newDeviceId: string) => {
    window.localStorage.setItem(SELECTED_AUDIO_INPUT_KEY, newDeviceId);
    track.restart({ deviceId: { exact: newDeviceId } });
    getLocalAudioTrack(newDeviceId);
  };

  return (
    <GridItem>
      <SimpleGrid
        bgColor="gray.700"
        roundedTop={8}
        templateColumns="fit-content(100%) 1fr"
        gap={3}
        paddingX="2rem"
        paddingY="1.5rem"
        shadow="md"
        alignItems="center"
      >
        <MdComputer size="2rem" />
        <Text fontSize="lg">Computer Audio</Text>
      </SimpleGrid>
      <SimpleGrid
        bgColor="gray.800"
        gap={3}
        paddingY="1rem"
        paddingX="2rem"
        roundedBottom={8}
        shadow="md"
      >
        <SimpleGrid templateColumns="1fr fit-content(100%)">
          <Text fontSize="md" flexWrap="nowrap">
            {track?.mediaStreamTrack.label || "No Local Audio"}
          </Text>
          {audioInputDevices.length > 1 && (
            <DeviceSelector
              icon={BiSlider}
              deviceList={audioInputDevices}
              callback={replaceTrack}
            />
          )}
        </SimpleGrid>
        <Divider />
        <SimpleGrid
          gap={3}
          templateColumns="fit-content(100%) 1fr fit-content(100%) 3fr"
          alignItems="center"
        >
          <FiMic />
          <AudioButton isSwitch />
          <GiSpeaker size="1.5rem" />
          <AudioLevelIndicator audioTrack={track} />
        </SimpleGrid>
      </SimpleGrid>
    </GridItem>
  );
};

export default AudioPreview;
